window.VDB_DIAMOND_SELECTED_VALUES = {
    page: 1,
    stone: "",
    origin: "",
    shape: "",
    color: "",
    looking: "",
    carat_min: 1.0,
    carat_max: 5.0,
    clarity: "",
    cut: "",
    limit: "",
    price_min: 0,
    price_max: 100000,
    tab_view: "grid",
    sorting: "total_sales_price",
    sorting_seq: "ASC",
    fcolor: "",
    polish: "",
    symmetry: "",
    depth_min: 1.00,
    depth_max: 100.00,
    table_min: 1.00,
    table_max: 100.00,
    item_number: ""
};

let urlParams = new URLSearchParams(window.location.search);
let url = new URL(window.location.href);

// table api call
let isFetching = false;
let controller;
let debounceTimer;

function vdbMainAPiCall(page = 1) {
    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(async () => {
        if (controller) {
        controller.abort();
        }
        controller = new AbortController();

        fetchDiamonds(page, controller);
        handleButtons();
    }, 500);
}

async function fetchDiamonds(page, controller ,loadMore = false) {

    const loader = document.querySelector("#vdbrb_list_cover_loader");
    const tableBody = document.querySelector("tbody");
    const gridViewDiv = document.querySelector("#vdbrb_stone_grid_view_row");
    let formData = new FormData();

    if (isFetching) return;
    isFetching = true;

    try {
        loader.style.display = "block";
        if (window.VDB_DIAMOND_SELECTED_VALUES.page == 1) {
            tableBody.innerHTML = "";
            gridViewDiv.innerHTML = "";
        }

        if (!loadMore) {
            window.VDB_DIAMOND_SELECTED_VALUES.page = 1;
        }

        let shapeStr = window.VDB_DIAMOND_SELECTED_VALUES.shape || "Round,Oval,Marquise,Heart,Princess,Cushion,Radiant,Emerald,Pear,Asscher";
        let action = window.VDB_DIAMOND_SELECTED_VALUES.origin === "natural" ? "get_natural_list" : "get_labgrown_list";

        formData.append("action", action);
        formData.append("shop", "macorina-joyeria-fina.myshopify.com");
        formData.append("shape_data", window?.VDB_IS_DIAMOND_SHAPE_SHOW ? shapeStr : '');
        formData.append("carat_max", window?.VDB_IS_CARAT_SHOW ? window.VDB_DIAMOND_SELECTED_VALUES.carat_max : '');
        formData.append("carat_min", window?.VDB_IS_CARAT_SHOW ? window.VDB_DIAMOND_SELECTED_VALUES.carat_min : '');
        formData.append("page_number", page);
        // if (window.VDB_DIAMOND_SELECTED_VALUES.tab_view == 'list') {
        formData.append("sorting_field", window.VDB_DIAMOND_SELECTED_VALUES.sorting);
        formData.append("sorting_seq", window.VDB_DIAMOND_SELECTED_VALUES.sorting_seq);
        // }
        formData.append("tab_view", window.VDB_DIAMOND_SELECTED_VALUES.tab_view);
        formData.append("with_images", "true");
        formData.append("clarity_data_wrap", window?.VDB_IS_CLARITY_SHOW ? window.VDB_DIAMOND_SELECTED_VALUES.clarity : '');
        formData.append("cut_data_wrap", window?.VDB_IS_CUT_SHOW ? window.VDB_DIAMOND_SELECTED_VALUES.cut : '');
        formData.append("max_price", window?.VDB_IS_DIAMOND_PRICE_SHOW ? window.VDB_DIAMOND_SELECTED_VALUES.price_max : '');
        formData.append("min_price", window?.VDB_IS_DIAMOND_PRICE_SHOW ? window.VDB_DIAMOND_SELECTED_VALUES.price_min : '');
        formData.append("polish_data_wrap", window?.VDB_IS_POLISH_SHOW ? window.VDB_DIAMOND_SELECTED_VALUES.polish : '');
        formData.append("color_data_wrap", window?.VDB_IS_COLOR_SHOW ? window.VDB_DIAMOND_SELECTED_VALUES.color : '');
        formData.append("symmetry_data_wrap", window?.VDB_IS_SYMMENTRY_SHOW ? window.VDB_DIAMOND_SELECTED_VALUES.symmetry : '');
        formData.append("min_depth", window?.VDB_IS_DEPTH_SHOW ? window.VDB_DIAMOND_SELECTED_VALUES.depth_min : '');
        formData.append("max_depth", window?.VDB_IS_DEPTH_SHOW ? window.VDB_DIAMOND_SELECTED_VALUES.depth_max : '');
        formData.append("min_table", window?.VDB_IS_TABLE_SHOW ? window.VDB_DIAMOND_SELECTED_VALUES.table_min : '');
        formData.append("max_table", window?.VDB_IS_TABLE_SHOW ? window.VDB_DIAMOND_SELECTED_VALUES.table_max : '');
        formData.append('rows', 25);

        console.log("API Request Payload:", Object.fromEntries(formData));
        console.log('=======> controller :::', controller);
        const response = await fetch("https://phpstack-998622-4818184.cloudwaysapps.com/frontend.php", {
            method: "POST",
            signal: controller.signal,
            body: formData
        });
        const data = await response.json();
        window.VDB_DIAMOND_SELECTED_VALUES.page = page
        console.log(" Full API Response:", data);

        const diamonds = data.main_data.response.body.diamonds;

        const selectedView = localStorage.getItem("selectedTabView")

        if (selectedView == "list" && window.VDB_DIAMOND_SELECTED_VALUES.tab_view == "list") {
            renderListView(diamonds, tableBody);
        }
        else if (selectedView == "grid" && window.VDB_DIAMOND_SELECTED_VALUES.tab_view == "grid") {
            renderGridView(diamonds, gridViewDiv);
        }

        loader.style.display = "none"
        isFetching = false;
        handleButtons();
    } catch (error) {
        console.error("Error fetching diamonds:", error);
        isFetching = false;
    }

    if (page == 1) {
        formData.append("only_count_fetch", "yes");
        vdbPageCountApi(formData);
    }
}

function vdbPageCountApi(formData) {
    fetch(`https://phpstack-998622-4818184.cloudwaysapps.com/frontend.php/frontend.php`, {
        method: "POST",
        body: formData,
    })
        .then((response) => response.json())
        .then((data) => {
            window.PAGE_COUNT_RESPONSE = data;
            let itemCountDiv = document.querySelector(".vdb-plp-counts span");
            itemCountDiv.innerHTML = data.total_count;
        })
        .catch((error) => {
            console.error("Error:", error);
            alert("An error occurred while fetching the data.");
        });
}

function handleButtons() {
    let btnview = document.querySelectorAll(".btn-view");
    if (btnview.length === 0) return;

    btnview.forEach((btn) => {
        btn.removeEventListener("click", toggleDiamondDetails);
        btn.addEventListener("click", toggleDiamondDetails);
    });
}

function toggleDiamondDetails(event) {
    const indexa = Number(event.currentTarget.getAttribute("data-index"));
    const btnview = event.currentTarget;

    const detailsRow = document.querySelector(`.diamond-details-row[data-index="${indexa}"]`);
    const detailsCard = detailsRow?.querySelector(".active-td");
    const diamondRow = document.querySelector(`.vdb-diamond-details-tr[data-index="${indexa}"]`);

    if (!detailsCard || !diamondRow) return;

    const isCurrentlyOpen = getComputedStyle(detailsCard).display !== "none";

    const allDetailsCards = document.querySelectorAll(".diamond-details-row .active-td");
    const allDiamondRows = document.querySelectorAll(".vdb-diamond-details-tr");
    const allButtons = document.querySelectorAll(".btn-view");

    allDetailsCards.forEach(card => card.style.display = "none");
    allDiamondRows.forEach(row => row.classList.remove("vdb-diamond-selected-row"));
    allButtons.forEach(btn => btn.classList.remove("active"));

    if (!isCurrentlyOpen) {
        diamondRow.classList.add("vdb-diamond-selected-row");
        btnview.classList.add("active");
        detailsCard.style.display = "table-cell";
    } else {
        btnview.classList.remove("active");
        diamondRow.classList.remove("vdb-diamond-selected-row");
        detailsCard.style.display = "none";
    }
}

function handleScroll() {
    if (isFetching) return;

    const scrollPosition = window.innerHeight + window.scrollY;
    const documentHeight = document.documentElement.scrollHeight - 300;

    if (scrollPosition >= documentHeight) {
        console.log(window.VDB_DIAMOND_SELECTED_VALUES.page);
        window.VDB_DIAMOND_SELECTED_VALUES.page++;
        vdbMainAPiCall(window.VDB_DIAMOND_SELECTED_VALUES.page);
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver(handleButtons);
    observer.observe(document.body, { childList: true, subtree: true });

    window.addEventListener("scroll", handleScroll);
    handleButtons();
});

function renderListView(diamonds, tableBody) {
    if (window.VDB_DIAMOND_SELECTED_VALUES.page == 1) {
        tableBody.innerHTML = "";
    }

    const allDiamondsCountElement = document.querySelector("#vdb-rb-results-count");
    let existingRows = tableBody.querySelectorAll("tr").length;
    let compareContainer = document.querySelector(".vdb-compare-container");
    const isCompareCheckIsDisabled = compareContainer.querySelectorAll(".vdb-compare-card").length >= 3;

    diamonds.forEach((diamond, index) => {
        const rowIndex = index + existingRows;
        const row = document.createElement("tr");
        row.classList.add("vdb-diamond-details-tr");
        row.setAttribute("data-index", rowIndex);

        row.innerHTML = `
        ${window.VDB_TABLE_SHAPE_SHOW == true ? `<td>${diamond.shape}</td>` : ""}
        ${window.VDB_TABLE_PRICE_SHOW == true ? `<td class="active">$${diamond.total_sales_price} MXN</td>` : ""}
        ${window.VDB_TABLE_CARAT_SHOW == true ? `<td>${diamond.size}</td>` : ""}
        ${window.VDB_TABLE_CUT_SHOW == true ? `<td >${diamond.cut && diamond.cut != 'null' ? diamond.cut : '-'}</td>` : ""}
        ${window.VDB_TABLE_COLOR_SHOW == true ? `<td >${diamond.color}</td>` : ""}
        ${window.VDB_TABLE_CLARITY_SHOW == true ? `<td >${diamond.clarity}</td>` : ""}
        <td class="btn-view" data-index="${rowIndex}"><span >${getSvgIcon()}</span></td>
        ${window.VDB_TABLE_COMPARE_SHOW == true ? `<td data-index="${rowIndex}"><input type="checkbox" class="diamond-checkbox" data-index="${index}" ${isCompareCheckIsDisabled ? "disabled" : ''}></td>` : ""}`

        const detailsRow = document.createElement("tr");
        detailsRow.classList.add("diamond-details-row");
        detailsRow.setAttribute("data-index", rowIndex);
        let SizeLater = url.searchParams.get("setting-ring-size") || '';

        let redirectKey = "";
        if (window.VDB_DIAMOND_SELECTED_VALUES.origin == "natural") {
            redirectKey = "natural_stock_num";
        } else if (window.VDB_DIAMOND_SELECTED_VALUES.origin == "lab-grown") {
            redirectKey = "labgrown_stock_num";
        }


        
        const { viewDetailLink, addToMount } = getDiamondUrls(diamond,redirectKey,SizeLater);
        
      
        detailsRow.innerHTML = `
                  <td colspan="8" class="active-td" style="display: none;">
                      <div class="vdb-diamond-details-card" >
                          <div class="vdb-diamond-image">
                              <button class="diamond-btn active">${getNaturalSvg()} ${window.VDB_DIAMOND_SELECTED_VALUES.origin == "natural" ? "Natural" : "Lab-Grown"}</button>
                              <img src="${diamond.image_thumb_url} " alt="Diamond" onerror="this.src='https://cdn.shopify.com/s/files/1/0913/9354/files/no-image.webp?v=1744957723'">
                          </div>
                          <div class="vdb-diamond-info">
                              <div class="vdb-details-list">
                                  <h2>${diamond.size} Quilate ${diamond.shape} Diamond</h2>
                                  <p class="td-price" style="border:none">$${diamond.total_sales_price} MXN</p>
                                  ${window.VDB_TABLE_CARAT_SHOW == true ? `<p>Quilate: ${diamond.size}</p>` : ""}
                                  ${window.VDB_TABLE_CUT_SHOW == true ? `<p id="table-cut">Corte: ${diamond.cut && diamond.cut != 'null' ? diamond.cut : '-'}</p>` : ""}
                                  ${window.VDB_TABLE_COLOR_SHOW == true ? `<p id="table-color" >Color: ${diamond.color}</p>` : ""}
                                  ${window.VDB_TABLE_CLARITY_SHOW == true ? `<p id="table-clarity" >Claridad: ${diamond.clarity}</p>` : ""}
                              </div>
                              <div class="vdb-btn-settings">
                                  <a href="${addToMount}" class="vdb-diamond-add-to-setting">Agregar a la montura</a>
                                  <a href="${viewDetailLink}" class="vdb-diamond-view-details">Ver detalles</a>
                              </div>
                          </div>
                      </div>
                  </td>`;

        tableBody.appendChild(row);
        tableBody.appendChild(detailsRow);
    });
    handleButtons();
}

function getDiamondUrls(diamond, redirectKey, SizeLater) {
  const urlParams = new URLSearchParams(window.location.search);
  const settingHandle = urlParams.get("setting-handle");
  const variant = urlParams.get("variant");

  let viewDetailLink = `/products/stone?${redirectKey}=${diamond.stock_num}&diamond_shape=${diamond.shape}&setting-ring-size=${SizeLater}`;
  let addToMount = "";
  if (settingHandle) {
    viewDetailLink += `&setting-handle=${settingHandle}&variant=${variant}&setting-ring-size=${SizeLater}`;
    addToMount = `/products/${settingHandle}?setting-handle=${settingHandle}&variant=${variant}&${redirectKey}=${diamond.stock_num}&origin=${window.VDB_DIAMOND_SELECTED_VALUES.origin}&setting-ring-size=${SizeLater}`;
  } else {
    addToMount = `/collections/testing-collection?${redirectKey}=${diamond.stock_num}&filter.p.m.custom.shape=${diamond.shape}&filter.p.m.custom.origin=${window.VDB_DIAMOND_SELECTED_VALUES.origin}`;
  }

  return {
    viewDetailLink,
    addToMount
  };
}

function renderGridView(diamonds, gridViewDiv) {
    if (window.VDB_DIAMOND_SELECTED_VALUES.page == 1) {
        gridViewDiv.innerHTML = "";
    }

    diamonds.forEach((diamond, index) => {
        const diamondCard = document.createElement("div");
        diamondCard.classList.add("vdb-rb-col-md-3", "vdb-rb-col-sm-6");
        let SizeLater = url.searchParams.get("setting-ring-size") || '';
        let VariantDiamond = url.searchParams.get("variant-diamond");
        let SettingHandleDiamond = url.searchParams.get("setting-handle-diamond");
        let OriginDiamond = url.searchParams.get("origin-diamond");

        let redirectKey = "";
        if (window.VDB_DIAMOND_SELECTED_VALUES.origin == "natural") {
            redirectKey = "natural_stock_num";
        } else if (window.VDB_DIAMOND_SELECTED_VALUES.origin == "lab-grown") {
            redirectKey = "labgrown_stock_num";
        }

        const { viewDetailLink, addToMount } = getDiamondUrls(diamond,redirectKey,SizeLater);
      
        diamondCard.innerHTML = `
              <div class="vdb-diamond-card vdb-rb-list-product-item" data-index="${index}">
                  <div class="vdb-diamond-card-header">
                  ${window.VDB_TABLE_COMPARE_SHOW == true ? `<label class="vdb-diamond-compare"><input type="checkbox" class="diamond-checkbox" data-index="${index}"> Comparar </label>` : ""}
                      <span class="vdb-diamond-natural-label">
                          ${getNaturalSvg()} ${window.VDB_DIAMOND_SELECTED_VALUES.origin == "natural" ? "Natural" : "Lab-Grown"}
                      </span>
                  </div>
                      <div class="vdb-rb-product-img-wrapper">
                          <img src="${diamond.image_thumb_url}" alt="${diamond.shape} ${diamond.size}ct" class="vdb-rb-img-fluid" onerror="this.src='https://cdn.shopify.com/s/files/1/0913/9354/files/no-image.webp?v=1744957723'">
                      </div>
                      <div class="vdb-diamond-card-details">
                          <p>${diamond.size} ct / ${diamond.shape} Diamond</p>
                          <p class="vdb-diamond-price">$${diamond.total_sales_price} MXN</p>
                          <a href="${addToMount}" class="vdb-diamond-add-to-setting">Agregar a la montura</a>
                          <a href="${viewDetailLink}" class="vdb-diamond-view-details">Ver detalles</a>
                      </div>
                  <input type="hidden" class="diamond-cut" value="${diamond.cut}"></span>
                  <input type="hidden" class="diamond-color" value="${diamond.color}"></span>
                  <input type="hidden" class="diamond-clarity" value="${diamond.clarity}"></span>
              </div>`;
        gridViewDiv.appendChild(diamondCard);
    });
}

function getSvgIcon() {
    return `<svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.6665 1L6.6665 6L1.6665 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`;
}

function getNaturalSvg() {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
                <path d="M5.99983 9.79017L0.51416 3.20492L2.09616 0.0415039H9.90349L11.4855 3.20492L5.99983 9.79017Z" fill="#71A891"></path>
            </svg>`;
}

function init() {
    console.log("===================init====================");
    initDiamondShapeFilter();
    initDiamondOrigin();
    initDiamondPrice();
    initColor();
    initCarat();
    initClarity();
    initCut();
    initPolish();
    initsymmetry();
    initDepth();
    initTable();
    initDiamondLooking();

    lookingremove();
    vdbMainAPiCall();
}

// sorting change
function sortingInit() {
    function changeSorting(event) {
        let sorbylowest = event.currentTarget.getAttribute("sort-by-lowest");
        let sortbyhighest = event.currentTarget.getAttribute("sort-by-highest");
        let dataValuettextset = document.querySelector(".Sort-label-add");

        if (window.VDB_DIAMOND_SELECTED_VALUES.sorting == event.currentTarget.getAttribute("data-t-head-value")) {
            window.VDB_DIAMOND_SELECTED_VALUES.sorting_seq = window.VDB_DIAMOND_SELECTED_VALUES.sorting_seq == "ASC" ? "DESC" : "ASC";
            vdbSetUrlParams("sorting_seq", window.VDB_DIAMOND_SELECTED_VALUES.sorting_seq);
        } else {
            window.VDB_DIAMOND_SELECTED_VALUES.sorting = event.currentTarget.getAttribute("data-t-head-value");
            window.VDB_DIAMOND_SELECTED_VALUES.sorting_seq = "ASC";
            vdbSetUrlParams("sorting", event.currentTarget.getAttribute("data-t-head-value"));
            vdbSetUrlParams("sorting_seq", "ASC");
        }

        let sortDiv = document.querySelectorAll("#table-th-sorting");
        sortDiv.forEach((item) => {
            item.classList.remove("vdb-asc-order");
            item.classList.remove("vdb-des-order");
            item.classList.remove("vdb-sort-order");
        });

        if (window.VDB_DIAMOND_SELECTED_VALUES.sorting_seq == "ASC") {
            event.currentTarget.classList.add("vdb-asc-order", "vdb-sort-order");
            localStorage.setItem("SortBy", sorbylowest);
        } else {
            event.currentTarget.classList.add("vdb-des-order", "vdb-sort-order");
            localStorage.setItem("SortBy", sortbyhighest);
        }

        const SortByloc = localStorage.getItem("SortBy");
        dataValuettextset.textContent = SortByloc;

        vdbMainAPiCall();
    }

    function changeSortingSortby(event) {
        let dataValue = event.currentTarget.getAttribute("data-value");
        let sortingValue = event.currentTarget.getAttribute("sorting-value");
        let dataValuetext = event.currentTarget.textContent.trim();
        let dataValuettextset = document.querySelector(".Sort-label-add");
        let sortbox = document.querySelector(".sort-box");
        let storedSortLabel = localStorage.getItem("sortLabel");
        let arrowsort = document.querySelector(".arrow-sort");
        const theadfilter = document.querySelector(`.vdb-diamond-table th[data-t-head-value="${dataValue}"]`);

        document.querySelectorAll("#table-th-sorting").forEach((item) => {
            item.classList.remove("vdb-asc-order", "vdb-des-order");
        });

        if (window.VDB_DIAMOND_SELECTED_VALUES.sorting === dataValue) {
            window.VDB_DIAMOND_SELECTED_VALUES.sorting_seq = sortingValue
        } else {
            window.VDB_DIAMOND_SELECTED_VALUES.sorting = dataValue;
            window.VDB_DIAMOND_SELECTED_VALUES.sorting_seq = sortingValue
        }

        vdbSetUrlParams("sorting", window.VDB_DIAMOND_SELECTED_VALUES.sorting);
        vdbSetUrlParams("sorting_seq", window.VDB_DIAMOND_SELECTED_VALUES.sorting_seq);
        console.log("sorting sorting_seq", window.VDB_DIAMOND_SELECTED_VALUES.sorting, window.VDB_DIAMOND_SELECTED_VALUES.sorting_seq);
        localStorage.setItem("SortBy", dataValuetext);

        if (window.VDB_DIAMOND_SELECTED_VALUES.sorting_seq === "ASC") {
            theadfilter.classList.add("vdb-asc-order", "vdb-sort-order");
        } else {
            theadfilter.classList.add("vdb-des-order", "vdb-sort-order");
        }
        sortbox.style.display = "none";
        arrowsort.style.transform = "rotate(45deg)";
        arrowsort.classList.remove('active-sort');

        const SortByloc = localStorage.getItem("SortBy");
        dataValuettextset.textContent = SortByloc;
        vdbMainAPiCall();
    }

    let url = new URL(window.location.href);
    let sorting = url.searchParams.get("sorting")
    let sortingSeq = url.searchParams.get("sorting_seq")
    if (sorting && sortingSeq) {
        vdbSetUrlParams("sorting", sorting);
        vdbSetUrlParams("sorting_seq", sortingSeq);
        window.VDB_DIAMOND_SELECTED_VALUES.sorting = sorting;
        window.VDB_DIAMOND_SELECTED_VALUES.sorting_seq = sortingSeq;
    } else {
        vdbSetUrlParams("sorting", "total_sales_price");
        vdbSetUrlParams("sorting_seq", "ASC");
        window.VDB_DIAMOND_SELECTED_VALUES.sorting = "total_sales_price";
        window.VDB_DIAMOND_SELECTED_VALUES.sorting_seq = "ASC";
    }

    let tableTh = document.querySelectorAll("#table-th-sorting");
    tableTh.forEach((item) => {
        item.classList.remove("vdb-asc-order");
        item.classList.remove("vdb-des-order");
    });

    tableTh.forEach((item) => {
        if (item.getAttribute("data-t-head-value") == window.VDB_DIAMOND_SELECTED_VALUES.sorting) {
            if (window.VDB_DIAMOND_SELECTED_VALUES.sorting_seq == "ASC") {
                item.classList.add("vdb-asc-order", "vdb-sort-order");
            } else {
                item.classList.add("vdb-des-order", "vdb-sort-order");
            }
        }
        item.addEventListener("click", changeSorting);
    });

    document.querySelectorAll(".sort-text-box-h4").forEach((item) => {
        item.addEventListener("click", changeSortingSortby);
    });
}

window.addEventListener("DOMContentLoaded", function () {
    const SortByloc = localStorage.getItem("SortBy");
    const dataValuettextset = document.querySelector(".Sort-label-add");
    dataValuettextset.textContent = SortByloc;
});


// Diamond Shape function
function initDiamondShapeFilter() {
    const shapeElements = document.querySelectorAll(".filter-option-img");
    const shapeQueryParam = urlParams.get("shape");

    if (shapeElements.length > 0) {
        shapeElements.forEach((shapeEl, index) => {
            if (!shapeQueryParam && index === 0) {
                updateSelectedShape(shapeEl.getAttribute("data-shape"));
            } else {
                shapeEl.classList.remove("active");
            }
            shapeEl.addEventListener("click", handleShapeClick);
        });

        if (shapeQueryParam) {
            const selectedShapeEl = document.querySelector(`[data-shape='${shapeQueryParam}']`);
            if (selectedShapeEl) {
                selectedShapeEl.classList.add("active");
                updateSelectedShape(selectedShapeEl.getAttribute("data-shape"));
            }
        } else {
            resetShapeSelection(shapeElements);
        }
    }
}

function handleShapeClick(event) {
    const clickedElement = event.currentTarget;
    const shapeElements = document.querySelectorAll(".filter-option-img");

    let wasSelected = clickedElement.classList.contains("active");
    shapeElements.forEach((el) => el.classList.remove("active"));

    if (!wasSelected) {
        clickedElement.classList.add("active");
        const shapeValue = clickedElement.getAttribute("data-shape");
        updateSelectedShape(shapeValue);
        vdbSetUrlParams("shape", shapeValue);
    } else {
        resetShapeSelection(shapeElements);
        const url = new URL(window.location);
        url.searchParams.delete("shape");
        window.history.pushState({}, "", url.toString());
    }
    window.VDB_DIAMOND_SELECTED_VALUES.page = 1;
    vdbMainAPiCall();
}

function updateSelectedShape(shapeValue) {
    window.VDB_DIAMOND_SELECTED_VALUES = window.VDB_DIAMOND_SELECTED_VALUES || {};
    window.VDB_DIAMOND_SELECTED_VALUES.shape = shapeValue;
}

function resetShapeSelection(shapeElements) {
    const allShapes = Array.from(shapeElements).map((el) => el.getAttribute("data-shape"));
    window.VDB_DIAMOND_SELECTED_VALUES = window.VDB_DIAMOND_SELECTED_VALUES || {};
    window.VDB_DIAMOND_SELECTED_VALUES.shape = allShapes.join(",");
}

// Looking function
function initDiamondLooking() {
    const filterOptions = document.querySelectorAll("#vdb-diamond-filter-option1");
    const qualityButtons = document.querySelectorAll("#vdb-diamond-filter-option2");

    filterOptions.forEach((option, index) => {
        option.addEventListener("click", () => handleFilterSelection(option, qualityButtons[index]));
    });

    qualityButtons.forEach((button, index) => {
        button.addEventListener("click", () => handleFilterSelection(filterOptions[index], button));
    });

    applyOriginSelection();
}

function handleFilterSelection(filterOption, qualityButton) {
    resetActiveStates();

    if (filterOption) filterOption.classList.add("active");
    if (qualityButton) qualityButton.classList.add("active");
}

function resetActiveStates() {
    document.querySelectorAll("#vdb-diamond-filter-option1, #vdb-diamond-filter-option2")
        .forEach(el => el.classList.remove("active"));
}

function applyOriginSelection() {
    const lookingQueryParam = new URL(window.location).searchParams.get("What_Are_You_Looking_For");
    const filterOptions = document.querySelectorAll("#vdb-diamond-filter-option1");
    const filterOptions2 = document.querySelectorAll("#vdb-diamond-filter-option2");

    filterOptions.forEach(option => {
        option.addEventListener("click", handleLookingSelection);
        lookingremove();
    });

    filterOptions2.forEach(option => {
        option.addEventListener("click", handleLookingSelection);
        lookingremove();
    });
}

function handleLookingSelection(event) {
    const selectedElement = event.currentTarget;
    const selectedValue = selectedElement.getAttribute("data-value");

    if (!selectedElement.classList.contains("vdb-diamond-filter-option")) return;

    const filterOptionsid1 = document.querySelector(`#vdb-diamond-filter-option1[data-value='${selectedValue}`);
    const filterOptionsid2 = document.querySelector(`#vdb-diamond-filter-option2[data-value='${selectedValue}`);

    resetActiveStates();
    filterOptionsid1.classList.add("active");
    filterOptionsid2.classList.add("active");

    if (!window.VDB_DIAMOND_SELECTED_VALUES) {
        window.VDB_DIAMOND_SELECTED_VALUES = {};
    }

    window.VDB_DIAMOND_SELECTED_VALUES.looking = selectedValue;
    vdbSetUrlParams("What_Are_You_Looking_For", selectedValue);
    console.log(window.VDB_DIAMOND_SELECTED_VALUES.looking);
}

function lookingremove() {
    if (!window.VDB_DIAMOND_SELECTED_VALUES) {
        window.VDB_DIAMOND_SELECTED_VALUES = {};
    }

    const selectedValues = window.VDB_DIAMOND_SELECTED_VALUES;

    selectedValues.color = selectedValues.color || [];
    selectedValues.clarity = selectedValues.clarity || [];
    selectedValues.cut = selectedValues.cut || [];
    selectedValues.polish = selectedValues.polish || [];
    selectedValues.symmetry = selectedValues.symmetry || [];

    let lookingValue = "";

    const MostPopular = document.querySelector(`#vdb-diamond-filter-option2[data-value='Most Popular']`);
    const BestBalance = document.querySelector(`#vdb-diamond-filter-option2[data-value='Best Balance']`);
    const UltraIdeale = document.querySelector(`#vdb-diamond-filter-option2[data-value='Ultra Ideale']`);

    const MostPopulard = document.querySelector(`#vdb-diamond-filter-option1[data-value='Most Popular']`);
    const BestBalanced = document.querySelector(`#vdb-diamond-filter-option1[data-value='Best Balance']`);
    const UltraIdealed = document.querySelector(`#vdb-diamond-filter-option1[data-value='Ultra Ideale']`);

    const isMostPopularActive =
        selectedValues.color.includes("D") &&
        selectedValues.color.includes("F") &&
        selectedValues.clarity.includes("FL") &&
        selectedValues.clarity.includes("VVS2") &&
        selectedValues.cut.includes("Ideal") &&
        selectedValues.cut.includes("Excellent") &&
        selectedValues.polish.includes("Ideal") &&
        selectedValues.polish.includes("Excellent") &&
        selectedValues.symmetry.includes("Ideal") &&
        selectedValues.symmetry.includes("Excellent");

    const isBestBalanceActive =
        selectedValues.color.includes("F") &&
        selectedValues.color.includes("H") &&
        selectedValues.clarity.includes("VS1") &&
        selectedValues.clarity.includes("SI1") &&
        selectedValues.cut.includes("Ideal") &&
        selectedValues.cut.includes("Excellent") &&
        selectedValues.polish.includes("Ideal") &&
        selectedValues.polish.includes("Excellent") &&
        selectedValues.symmetry.includes("Ideal") &&
        selectedValues.symmetry.includes("Excellent");

    const isUltraIdealActive =
        selectedValues.color.includes("H") &&
        selectedValues.color.includes("J") &&
        selectedValues.clarity.includes("VS2") &&
        selectedValues.clarity.includes("SI2") &&
        selectedValues.cut.includes("VeryGood") &&
        selectedValues.polish.includes("VeryGood") &&
        selectedValues.symmetry.includes("VeryGood");

    MostPopular.classList.remove("active");
    MostPopulard.classList.remove("active");
    BestBalance.classList.remove("active");
    BestBalanced.classList.remove("active");
    UltraIdeale.classList.remove("active");
    UltraIdealed.classList.remove("active");

    if (isMostPopularActive) {
        MostPopular.classList.add("active");
        MostPopulard.classList.add("active");
        lookingValue = "Most Popular";
    }

    if (isBestBalanceActive) {
        BestBalance.classList.add("active");
        BestBalanced.classList.add("active");
        lookingValue = "Best Balance";
    }

    if (isUltraIdealActive) {
        UltraIdeale.classList.add("active");
        UltraIdealed.classList.add("active");
        lookingValue = "Ultra Ideale";
    }

    // if (lookingValue) {
    //     vdbSetUrlParams("What_Are_You_Looking_For", lookingValue);
    //     window.VDB_DIAMOND_SELECTED_VALUES.looking = lookingValue;
    // } else {
    //     window.VDB_DIAMOND_SELECTED_VALUES.looking = null;
    //     const url = new URL(window.location);
    //     url.searchParams.delete("What_Are_You_Looking_For");
    //     window.history.replaceState({}, "", url);
    // }
    vdbMainAPiCall();
}

// Diamond Origin
function initDiamondOrigin() {
    const vdbOrigins1 = document.querySelectorAll("#vdb-varriant-stones2");
    const vdbOrigins2 = document.querySelectorAll("#vdb-varriant-stones1");

    if (vdbOrigins1.length > 0 && vdbOrigins2.length > 0) {
        vdbOrigins1.forEach((option, index) => {
            option.addEventListener("click", function () {
                vdbOrigins1.forEach(opt => opt.classList.remove("active"));
                vdbOrigins2.forEach(btn => btn.classList.remove("active"));

                this.classList.add("active");

                if (vdbOrigins2[index]) {
                    vdbOrigins2[index].classList.add("active");
                }
            });
        });

        vdbOrigins2.forEach((button, index) => {
            button.addEventListener("click", function () {
                vdbOrigins1.forEach(opt => opt.classList.remove("active"));
                vdbOrigins2.forEach(btn => btn.classList.remove("active"));

                this.classList.add("active");

                if (vdbOrigins1[index]) {
                    vdbOrigins1[index].classList.add("active");
                }
            });
        });
    }
    applyOriginSelection2();
}

function applyOriginSelection2() {

    let originQueryParam = urlParams.get("Diamond_Origin");
    let activeSet = false;

    window.vdbOriginsclass1 = document.querySelectorAll(".vdb-varriant-stones");

    if (!window.VDB_DIAMOND_SELECTED_VALUES) {
        window.VDB_DIAMOND_SELECTED_VALUES = {};
    }

    if (window.vdbOriginsclass1.length > 0) {
        window.vdbOriginsclass1.forEach((originVar) => {
            originVar.addEventListener("click", originClickedlooking2);

            if (originQueryParam && originVar.getAttribute("data-value") === originQueryParam) {
                originVar.classList.add("active");
                addActiveToPairlooking2(originVar.getAttribute("data-value"));
                window.VDB_DIAMOND_SELECTED_VALUES.origin = originVar.getAttribute("data-value");
                activeSet = true;
            } else {
                originVar.classList.remove("active");
            }
        });

        if (!originQueryParam && !activeSet && window.vdbOriginsclass1[0]) {
            window.vdbOriginsclass1[0].classList.add("active");
            addActiveToPairlooking2(window.vdbOriginsclass1[0].getAttribute("data-value"));
            window.VDB_DIAMOND_SELECTED_VALUES.origin = window.vdbOriginsclass1[0].getAttribute("data-value");
        }
        vdbSetUrlParams("Diamond_Origin", window.VDB_DIAMOND_SELECTED_VALUES.origin);
    }


}

function originClickedlooking2(event) {
    if (!event.currentTarget.classList.contains("vdb-varriant-stones")) return;

    window.vdbOriginsclass1.forEach(stone => stone.classList.remove("active"));

    event.currentTarget.classList.add("active");
    const selectedValue2 = event.currentTarget.getAttribute("data-value");

    addActiveToPairlooking2(selectedValue2);

    window.VDB_DIAMOND_SELECTED_VALUES.origin = selectedValue2;
    vdbSetUrlParams("Diamond_Origin", selectedValue2);

    window.VDB_DIAMOND_SELECTED_VALUES.page = 1;
    vdbMainAPiCall();
}

function addActiveToPairlooking2(value) {
    window.vdbOriginsclass1.forEach(stone => {
        if (stone.getAttribute("data-value") === value) {
            stone.classList.add("active");
        }
    });
}

// Diamond Price function
function initDiamondPrice() {
    const fromSlider = document.getElementById("vbdrb_price_from_slider_natural_web");
    const toSlider = document.getElementById("vbdrb_price_to_slider_natural_web");
    const fromInput = document.getElementById("vbdrb_price_from_slider_input_natural_web");
    const toInput = document.getElementById("vbdrb_price_to_slider_input_natural_web");

    const minPrice = parseFloat(fromSlider.min) || 0;
    const maxPrice = parseFloat(toSlider.max) || 10000;

    function updateSliderFill() {
        const fromValue = parseFloat(fromSlider.value);
        const toValue = parseFloat(toSlider.value);

        if (isNaN(fromValue) || isNaN(toValue)) return;

        const fromPercent = ((fromValue - minPrice) / (maxPrice - minPrice)) * 100;
        const toPercent = ((toValue - minPrice) / (maxPrice - minPrice)) * 100;

        const gradient = `linear-gradient(to right, #eee ${fromPercent}%, #71a891 ${fromPercent}%, #71a891 ${toPercent}%, #eee ${toPercent}%)`;
        fromSlider.style.background = gradient;
        toSlider.style.background = gradient;
    }

    function updateValues(triggerApi = true) {
        let fromValue = parseFloat(fromSlider.value);
        let toValue = parseFloat(toSlider.value);

        if (fromValue > toValue) fromValue = toValue;
        if (toValue < fromValue) toValue = fromValue;

        fromInput.value = fromValue;
        toInput.value = toValue;
        fromSlider.value = fromValue;
        toSlider.value = toValue;

        if (typeof window.VDB_DIAMOND_SELECTED_VALUES !== "object") {
            window.VDB_DIAMOND_SELECTED_VALUES = {};
        }

        window.VDB_DIAMOND_SELECTED_VALUES.price_min = fromValue;
        window.VDB_DIAMOND_SELECTED_VALUES.price_max = toValue;
        window.VDB_DIAMOND_SELECTED_VALUES.page = 1;

        vdbSetUrlParams("price_from", fromValue);
        vdbSetUrlParams("price_to", toValue);
        updateSliderFill();

        if (triggerApi) {
            vdbMainAPiCall();
        }
    }

    function validateInput(input, slider) {
        let value = parseFloat(input.value);
        if (isNaN(value) || value < minPrice) value = minPrice;
        if (value > maxPrice) value = maxPrice;

        input.value = value;
        slider.value = value;
        updateValues();
    }

    function applyInitialValues() {
        const params = new URLSearchParams(window.location.search);
        let fromValue = params.get("price_from") ? parseFloat(params.get("price_from")) : minPrice;
        let toValue = params.get("price_to") ? parseFloat(params.get("price_to")) : maxPrice;

        if (isNaN(fromValue) || fromValue < minPrice) fromValue = minPrice;
        if (isNaN(toValue) || toValue > maxPrice) toValue = maxPrice;
        if (fromValue > toValue) fromValue = toValue;

        fromSlider.value = fromValue;
        toSlider.value = toValue;
        fromInput.value = fromValue;
        toInput.value = toValue;

        updateSliderFill();
        updateValues(false);
    }

    fromSlider.addEventListener("input", () => updateValues(true));
    toSlider.addEventListener("input", () => updateValues(true));
    fromInput.addEventListener("input", () => validateInput(fromInput, fromSlider));
    toInput.addEventListener("input", () => validateInput(toInput, toSlider));

    applyInitialValues();
}

//Color function
function initColor() {
    const fromSlider = document.getElementById("vbdrb_white_color_from_slider_natural_web");
    const toSlider = document.getElementById("vbdrb_white_color_to_slider_natural_web");
    const fromInput = document.getElementById("vbdrb_white_color_from_slider_input_natural_web");
    const toInput = document.getElementById("vbdrb_white_color_to_slider_input_natural_web");

    color_input_value = [];
    if (window.vdbColorSetting) {
        for (var key of Object.keys(window.vdbColorSetting)) {
            if (window.vdbColorSetting[key]) {
                color_input_value.push(key);
            }
        }
    }

    function updateSliderFill() {
        const fromValue = parseInt(fromSlider.value, 10);
        const toValue = parseInt(toSlider.value, 10);
        const min = 0;
        const max = color_input_value.length - 1;

        const fromPercent = ((fromValue - min) / (max - min)) * 100;
        const toPercent = ((toValue - min) / (max - min)) * 100;
        const gradient = `linear-gradient(to right, #eee ${fromPercent}%, #71a891 ${fromPercent}%, #71a891 ${toPercent}%, #eee ${toPercent}%)`;

        fromSlider.style.background = gradient;
        toSlider.style.background = gradient;
    }

    function updateInputValues() {
        const fromIndex = parseInt(fromSlider.value, 10);
        const toIndex = parseInt(toSlider.value, 10);

        const fromValue = color_input_value[fromIndex];
        const toValue = color_input_value[toIndex];

        fromInput.value = fromValue;
        toInput.value = toValue;

        console.log('======> Color fromindex, toIndex ::: Final value update :::' , fromIndex, toIndex, fromInput.value, toInput.value);

        vdbSetUrlParams("color_from", fromValue);
        vdbSetUrlParams("color_to", toValue);

        const sliderLabels = document.querySelectorAll(".vdb-grid-slider-label");
        sliderLabels.forEach(label => label.classList.remove("vdb-slider-label-active"));

        const fromLabel = document.querySelector(`[data-value="${fromValue}"]`);
        const toLabel = document.querySelector(`[data-value="${toValue}"]`);
        if (fromLabel) fromLabel.classList.add("vdb-slider-label-active");
        if (toLabel) toLabel.classList.add("vdb-slider-label-active");

        window.VDB_DIAMOND_SELECTED_VALUES.color = [toValue, fromValue].join(",");
        window.VDB_DIAMOND_SELECTED_VALUES.page = 1;
    }

    function applyInitialValues() {
        const params = new URLSearchParams(window.location.search);
        const fromParam = params.get("color_from") || color_input_value[0];
        const toParam = params.get("color_to") || color_input_value[color_input_value.length - 1];

        const fromIndex = color_input_value.indexOf(fromParam);
        const toIndex = color_input_value.indexOf(toParam);

        fromSlider.value = fromIndex !== -1 ? fromIndex : 0;
        toSlider.value = toIndex !== -1 ? toIndex : color_input_value.length - 1;

        updateSliderFill();
        updateInputValues();
    }

    function updateSliderLooking() {
        let fromValue, toValue;

        switch (window.VDB_DIAMOND_SELECTED_VALUES?.looking) {
            case "Most Popular":
                fromValue = "D";
                toValue = "F";
                break;
            case "Best Balance":
                fromValue = "F";
                toValue = "H";
                break;
            case "Ultra Ideale":
                fromValue = "H";
                toValue = "J";
                break;
            default:
                console.warn("Invalid looking value:", window.VDB_DIAMOND_SELECTED_VALUES?.looking);
                return;
        }

        const fromIndex = color_input_value.indexOf(fromValue);
        const toIndex = color_input_value.indexOf(toValue);

        if (fromIndex !== -1 && toIndex !== -1) {
            fromSlider.value = fromIndex;
            toSlider.value = toIndex;
            updateSliderFill();
            updateInputValues();
        }
    }

    fromSlider.addEventListener("input", () => {
        const fromIndex = parseInt(fromSlider.value, 10);
        const toIndex = parseInt(toSlider.value, 10);
        if (fromIndex >= toIndex) {
            fromSlider.value = toIndex;
        }
      
        updateSliderFill();
        updateInputValues();
        lookingremove();
        vdbMainAPiCall();
    });

    toSlider.addEventListener("input", () => {
        const fromIndex = parseInt(fromSlider.value, 10);
        const toIndex = parseInt(toSlider.value, 10);

        if (fromIndex >= toIndex) {
            toSlider.value = fromIndex;
        }
        updateSliderFill();
        updateInputValues();
        lookingremove();
        vdbMainAPiCall();
    });

    let lastLookingValue = window.VDB_DIAMOND_SELECTED_VALUES?.looking || "";
    setInterval(() => {
        if (window.VDB_DIAMOND_SELECTED_VALUES.looking !== lastLookingValue) {
            lastLookingValue = window.VDB_DIAMOND_SELECTED_VALUES.looking;
            updateSliderLooking();
        }
    }, 500);

    applyInitialValues();
}


// Carat function
function initCarat() {
    const fromSlider = document.getElementById("vbdrb_carat_from_slider_natural_web");
    const toSlider = document.getElementById("vbdrb_carat_to_slider_natural_web");
    const fromInput = document.getElementById("vbdrb_carat_from_slider_input_natural_web");
    const toInput = document.getElementById("vbdrb_carat_to_slider_input_natural_web");

    const minCarat = parseFloat(fromSlider.min) || 0;
    const maxCarat = parseFloat(toSlider.max) || 5;

    function updateSliderFill() {
        const fromValue = parseFloat(fromSlider.value);
        const toValue = parseFloat(toSlider.value);

        const fromPercent = ((fromValue - minCarat) / (maxCarat - minCarat)) * 100;
        const toPercent = ((toValue - minCarat) / (maxCarat - minCarat)) * 100;

        const gradient = `linear-gradient(to right, #eee ${fromPercent}%, #71a891 ${fromPercent}%, #71a891 ${toPercent}%, #eee ${toPercent}%)`;
        fromSlider.style.background = gradient;
        toSlider.style.background = gradient;
    }

    function updateInputs(triggerApi = true) {
        let fromValue = parseFloat(fromSlider.value);
        let toValue = parseFloat(toSlider.value);

        if (fromValue > toValue) fromValue = toValue;
        if (toValue < fromValue) toValue = fromValue;

        fromInput.value = fromValue;
        toInput.value = toValue;
        fromSlider.value = fromValue;
        toSlider.value = toValue;

        if (typeof window.VDB_DIAMOND_SELECTED_VALUES !== "object") {
            window.VDB_DIAMOND_SELECTED_VALUES = {};
        }

        window.VDB_DIAMOND_SELECTED_VALUES.carat_min = fromValue;
        window.VDB_DIAMOND_SELECTED_VALUES.carat_max = toValue;
        window.VDB_DIAMOND_SELECTED_VALUES.page = 1;

        vdbSetUrlParams("carat_from", fromValue);
        vdbSetUrlParams("carat_to", toValue);

        updateSliderFill();
        if (triggerApi) {
            vdbMainAPiCall();
        }
    }

    function validateInput(input, slider) {
        let value = parseFloat(input.value);
        if (isNaN(value) || value < minCarat) value = minCarat;
        if (value > maxCarat) value = maxCarat;

        input.value = value;
        slider.value = value;
        updateInputs();
    }

    function applyInitialValues() {
        const params = new URLSearchParams(window.location.search);
        let fromValue = params.get("carat_from") ? parseFloat(params.get("carat_from")) : minCarat;
        let toValue = params.get("carat_to") ? parseFloat(params.get("carat_to")) : maxCarat;

        if (isNaN(fromValue) || fromValue < minCarat) fromValue = minCarat;
        if (isNaN(toValue) || toValue > maxCarat) toValue = maxCarat;
        if (fromValue > toValue) fromValue = toValue;

        fromSlider.value = fromValue;
        toSlider.value = toValue;
        fromInput.value = fromValue;
        toInput.value = toValue;

        updateSliderFill();
        updateInputs(false);
    }

    fromSlider.addEventListener("input", () => updateInputs(true));
    toSlider.addEventListener("input", () => updateInputs(true));
    fromInput.addEventListener("input", () => validateInput(fromInput, fromSlider));
    toInput.addEventListener("input", () => validateInput(toInput, toSlider));

    applyInitialValues();
}

// Clarity function
function initClarity() {
    const fromSlider = document.getElementById("vbdrb_clarity_from_slider_natural_web");
    const toSlider = document.getElementById("vbdrb_clarity_to_slider_natural_web");
    const fromInput = document.getElementById("vbdrb_clarity_from_slider_input_natural_web");
    const toInput = document.getElementById("vbdrb_clarity_to_slider_input_natural_web");

    clarity_input_value = [];
    if (window.vdbClaritySetting) {
        for (var key of Object.keys(window.vdbClaritySetting)) {
            if (window.vdbClaritySetting[key]) {
                clarity_input_value.push(key);
            }
        }
    }

    function updateSliderFill() {
        const fromValue = parseInt(fromSlider.value, 10);
        const toValue = parseInt(toSlider.value, 10);
        const min = 0;
        const max = clarity_input_value.length - 1;

        const fromPercent = ((fromValue - min) / (max - min)) * 100;
        const toPercent = ((toValue - min) / (max - min)) * 100;
        const gradient = `linear-gradient(to right, #eee ${fromPercent}%, #71a891 ${fromPercent}%, #71a891 ${toPercent}%, #eee ${toPercent}%)`;

        fromSlider.style.background = gradient;
        toSlider.style.background = gradient;
    }

    function updateInputValues() {
        const fromIndex = parseInt(fromSlider.value, 10);
        const toIndex = parseInt(toSlider.value, 10);

        const fromValue = clarity_input_value[fromIndex];
        const toValue = clarity_input_value[toIndex];

        fromInput.value = fromValue;
        toInput.value = toValue;

        vdbSetUrlParams("clarity_from", fromValue);
        vdbSetUrlParams("clarity_to", toValue);

        window.VDB_DIAMOND_SELECTED_VALUES.clarity = [toValue, fromValue].join(",");
        window.VDB_DIAMOND_SELECTED_VALUES.page = 1;

        const sliderLabels = document.querySelectorAll(".vdb-clarity-slider-label");
        sliderLabels.forEach(label => label.classList.remove("vdb-slider-label-active"));

        const fromLabel = document.querySelector(`[data-value="${fromValue}"]`);
        const toLabel = document.querySelector(`[data-value="${toValue}"]`);
        if (fromLabel) fromLabel.classList.add("vdb-slider-label-active");
        if (toLabel) toLabel.classList.add("vdb-slider-label-active");
    }

    function applyInitialValues() {
        const params = new URLSearchParams(window.location.search);
        const fromParam = params.get("clarity_from") || clarity_input_value[0];
        const toParam = params.get("clarity_to") || clarity_input_value[clarity_input_value.length - 1];

        const fromIndex = clarity_input_value.indexOf(fromParam);
        const toIndex = clarity_input_value.indexOf(toParam);

        fromSlider.value = fromIndex !== -1 ? fromIndex : 0;
        toSlider.value = toIndex !== -1 ? toIndex : clarity_input_value.length - 1;

        updateSliderFill();
        updateInputValues();
    }

    function updateSliderLooking() {
        let fromValue, toValue;

        switch (window.VDB_DIAMOND_SELECTED_VALUES?.looking) {
            case "Most Popular":
                fromValue = "FL";
                toValue = "VVS2";
                break;
            case "Best Balance":
                fromValue = "VS1";
                toValue = "SI1";
                break;
            case "Ultra Ideale":
                fromValue = "VS2";
                toValue = "SI2";
                break;
            default:
                console.warn("Invalid looking value:", window.VDB_DIAMOND_SELECTED_VALUES?.looking);
                return;
        }

        const fromIndex = clarity_input_value.indexOf(fromValue);
        const toIndex = clarity_input_value.indexOf(toValue);

        if (fromIndex !== -1 && toIndex !== -1) {
            fromSlider.value = fromIndex;
            toSlider.value = toIndex;
            updateSliderFill();
            updateInputValues();
        }
    }

    fromSlider.addEventListener("input", () => {
        const fromIndex = parseInt(fromSlider.value, 10);
        const toIndex = parseInt(toSlider.value, 10);

        if (fromIndex >= toIndex) {
          fromSlider.value = toIndex;
        }
        updateSliderFill();
        updateInputValues();
        lookingremove();
        vdbMainAPiCall();
    });

    toSlider.addEventListener("input", () => {
        const fromIndex = parseInt(fromSlider.value, 10);
        const toIndex = parseInt(toSlider.value, 10);

        if (fromIndex >= toIndex) {
          toSlider.value = fromIndex;
        }
        updateSliderFill();
        updateInputValues();
        lookingremove();
        vdbMainAPiCall();
    });

    let lastLookingValue = window.VDB_DIAMOND_SELECTED_VALUES.looking;
    setInterval(() => {
        if (window.VDB_DIAMOND_SELECTED_VALUES.looking !== lastLookingValue) {
            lastLookingValue = window.VDB_DIAMOND_SELECTED_VALUES.looking;
            updateSliderLooking();
        }
    }, 500);

    applyInitialValues();
}


//Cut function
function initCut() {
    const fromSlider = document.getElementById('vbdrb_cut_from_slider_natural_web');
    const toSlider = document.getElementById('vbdrb_cut_to_slider_natural_web');

    Cut_value_arr = [];
    if (window.vdbCutSetting) {
        for (var key of Object.keys(window.vdbCutSetting)) {
            if (window.vdbCutSetting[key]) {
                Cut_value_arr.push(key);
            }
        }
    }

    function updateSliderBackground() {
        const fromPercent = (fromSlider.value / fromSlider.max) * 100;
        const toPercent = (toSlider.value / toSlider.max) * 100;

        toSlider.style.background = `linear-gradient(to right, rgb(240, 240, 240) ${fromPercent}%, rgb(113, 168, 145) ${fromPercent}%, rgb(113, 168, 145) ${toPercent}%, rgb(240, 240, 240) ${toPercent}%)`;
    }

    function updateInputValues() {
        const fromIndex = Math.min(Math.max(parseInt(fromSlider.value, 10), 0), Cut_value_arr.length - 1);
        const toIndex = Math.min(Math.max(parseInt(toSlider.value, 10), 0), Cut_value_arr.length - 1);

        const fromValue = Cut_value_arr[fromIndex] || "Unknown";
        const toValue = Cut_value_arr[toIndex] || "Unknown";

        vdbSetUrlParams("cut_from", fromValue);
        vdbSetUrlParams("cut_to", toValue);

        document.querySelectorAll(".vdb-slider-label-Cut").forEach(label => label.classList.remove("vdb-slider-label-active"));

        const fromLabel = document.querySelector(`.vdb-slider-label-Cut[data-value="${fromValue}"]`);
        const toLabel = document.querySelector(`.vdb-slider-label-Cut[data-value="${toValue}"]`);

        if (fromLabel) fromLabel.classList.add("vdb-slider-label-active");
        if (toLabel) toLabel.classList.add("vdb-slider-label-active");

        window.VDB_DIAMOND_SELECTED_VALUES.cut = [fromValue, toValue].join(",");
        window.VDB_DIAMOND_SELECTED_VALUES.page = 1;
    }

    function applyInitialValues() {
        const params = new URLSearchParams(window.location.search);
        const fromParam = params.get("cut_from") || Cut_value_arr[0];
        const toParam = params.get("cut_to") || Cut_value_arr[Cut_value_arr.length - 1];

        const fromIndex = Cut_value_arr.indexOf(fromParam);
        const toIndex = Cut_value_arr.indexOf(toParam);

        fromSlider.value = fromIndex !== -1 ? fromIndex : 0;
        toSlider.value = toIndex !== -1 ? toIndex : Cut_value_arr.length - 1;

        updateSliderBackground();
        updateInputValues();
    }

    function updateSliderLooking() {
        let fromValue, toValue;
        let looking = window.VDB_DIAMOND_SELECTED_VALUES?.looking;

        switch (looking) {
            case "Most Popular":
            case "Best Balance":
                fromValue = "Ideal";
                toValue = "Excellent";
                break;
            case "Ultra Ideale":
                fromValue = "VeryGood";
                toValue = "VeryGood";
                break;
            default:
                console.warn("Invalid looking value:", looking);
                return;
        }

        const fromIndex = Cut_value_arr.indexOf(fromValue);
        const toIndex = Cut_value_arr.indexOf(toValue);

        window.VDB_DIAMOND_SELECTED_VALUES.cut = [fromValue, toValue].join(",");

        if (fromIndex !== -1 && toIndex !== -1) {
            fromSlider.value = fromIndex;
            toSlider.value = toIndex;
            updateSliderBackground();
            updateInputValues();
        }
    }

    fromSlider.addEventListener('input', () => {

         const fromIndex = parseInt(fromSlider.value, 10);
        const toIndex = parseInt(toSlider.value, 10);

        if (fromIndex >= toIndex) {
          fromSlider.value = toIndex;
        }
        updateInputValues();
        updateSliderBackground();
        lookingremove();
        vdbMainAPiCall();
    });

    toSlider.addEventListener('input', () => {
        const fromIndex = parseInt(fromSlider.value, 10);
        const toIndex = parseInt(toSlider.value, 10);

        if (fromIndex >= toIndex) {
          toSlider.value = fromIndex;
        }
      
        updateInputValues();
        updateSliderBackground();
        lookingremove();
        vdbMainAPiCall();
    });

    let lastLookingValue = window.VDB_DIAMOND_SELECTED_VALUES?.looking || "";
    setInterval(() => {
        if (window.VDB_DIAMOND_SELECTED_VALUES?.looking !== lastLookingValue) {
            lastLookingValue = window.VDB_DIAMOND_SELECTED_VALUES?.looking;
            updateSliderLooking();
        }
    }, 500);

    applyInitialValues();
}


// Polish Slider
function initPolish() {
    const fromSlider = document.getElementById('vbdrb_Polish_from_slider_natural_web');
    const toSlider = document.getElementById('vbdrb_Polish_to_slider_natural_web');
    const fromInput = document.getElementById('vbdrb_Polish_from_slider_input_natural_web');
    const toInput = document.getElementById('vbdrb_Polish_to_slider_input_natural_web');

    Polish_Slider_value_arr = [];
    if (window.vdbPolishSetting) {
        for (var key of Object.keys(window.vdbPolishSetting)) {
            if (window.vdbPolishSetting[key]) {
                Polish_Slider_value_arr.push(key);
            }
        }
    }

    function updateSliderBackground() {
        const fromPercent = (fromSlider.value / fromSlider.max) * 100;
        const toPercent = (toSlider.value / toSlider.max) * 100;

        toSlider.style.background = `linear-gradient(to right, rgb(240, 240, 240) ${fromPercent}%, rgb(113, 168, 145) ${fromPercent}%, rgb(113, 168, 145) ${toPercent}%, rgb(240, 240, 240) ${toPercent}%)`;
    }

    function updateInputValues() {
        const fromIndex = Math.min(Math.max(parseInt(fromSlider.value, 10), 0), Polish_Slider_value_arr.length - 1);
        const toIndex = Math.min(Math.max(parseInt(toSlider.value, 10), 0), Polish_Slider_value_arr.length - 1);

        const fromValue = Polish_Slider_value_arr[fromIndex] || "Unknown";
        const toValue = Polish_Slider_value_arr[toIndex] || "Unknown";

        vdbSetUrlParams("Polish_from", fromValue);
        vdbSetUrlParams("Polish_to", toValue);

        window.VDB_DIAMOND_SELECTED_VALUES.polish = [fromValue, toValue].join(",");
        window.VDB_DIAMOND_SELECTED_VALUES.page = 1;

        document.querySelectorAll(".vdb-slider-label-Polish").forEach(label => label.classList.remove("vdb-slider-label-active"));

        const fromLabel = document.querySelector(`.vdb-slider-label-Polish[data-value="${fromValue}"]`);
        const toLabel = document.querySelector(`.vdb-slider-label-Polish[data-value="${toValue}"]`);

        if (fromLabel) fromLabel.classList.add("vdb-slider-label-active");
        if (toLabel) toLabel.classList.add("vdb-slider-label-active");

    }

    function applyInitialValues() {
        const params = new URLSearchParams(window.location.search);
        const fromParam = params.get("Polish_from") || Polish_Slider_value_arr[0];
        const toParam = params.get("Polish_to") || Polish_Slider_value_arr[Polish_Slider_value_arr.length - 1];

        const fromIndex = Polish_Slider_value_arr.indexOf(fromParam);
        const toIndex = Polish_Slider_value_arr.indexOf(toParam);

        fromSlider.value = fromIndex !== -1 ? fromIndex : 0;
        toSlider.value = toIndex !== -1 ? toIndex : Polish_Slider_value_arr.length - 1;

        updateSliderBackground();
        updateInputValues();
    }

    function updateSliderLooking() {
        let fromValue, toValue;
        let looking = window.VDB_DIAMOND_SELECTED_VALUES?.looking;

        switch (looking) {
            case "Most Popular":
            case "Best Balance":
                fromValue = "Ideal";
                toValue = "Excellent";
                break;
            case "Ultra Ideale":
                fromValue = "VeryGood";
                toValue = "VeryGood";
                break;
            default:
                console.warn("Invalid looking value:", looking);
                return;
        }

        const fromIndex = Polish_Slider_value_arr.indexOf(fromValue);
        const toIndex = Polish_Slider_value_arr.indexOf(toValue);

        if (fromIndex === -1 || toIndex === -1) {
            console.error("Polish values not found:", fromValue, toValue);
            return;
        }

        fromSlider.value = fromIndex;
        toSlider.value = toIndex;
        updateSliderBackground();
        updateInputValues();
    }

    fromSlider.addEventListener('input', () => {
        const fromIndex = parseInt(fromSlider.value, 10);
        const toIndex = parseInt(toSlider.value, 10);

        if (fromIndex >= toIndex) {
          fromSlider.value = toIndex;
        }
        updateInputValues();
        updateSliderBackground();
        lookingremove();
        vdbMainAPiCall();
    });

    toSlider.addEventListener('input', () => {
        const fromIndex = parseInt(fromSlider.value, 10);
        const toIndex = parseInt(toSlider.value, 10);

        if (fromIndex >= toIndex) {
          toSlider.value = fromIndex;
        }
        updateInputValues();
        updateSliderBackground();
        lookingremove();
        vdbMainAPiCall();
    });

    let lastLookingValue = window.VDB_DIAMOND_SELECTED_VALUES?.looking;
    setInterval(() => {
        if (window.VDB_DIAMOND_SELECTED_VALUES?.looking !== lastLookingValue) {
            lastLookingValue = window.VDB_DIAMOND_SELECTED_VALUES?.looking;
            updateSliderLooking();
        }
    }, 500);

    applyInitialValues();
}

// Symmentry Slider
function initsymmetry() {
    const fromSlider = document.getElementById('vbdrb_Symmentry_from_slider_natural_web');
    const toSlider = document.getElementById('vbdrb_Symmentry_to_slider_natural_web');
    const fromInput = document.getElementById('vbdrb_Symmentry_from_slider_input_natural_web');
    const toInput = document.getElementById('vbdrb_Symmentry_to_slider_input_natural_web');

    symmetry_slider_value_arr = [];
    if (window.vdbSymmentrySetting) {
        for (var key of Object.keys(window.vdbSymmentrySetting)) {
            if (window.vdbSymmentrySetting[key]) {
                symmetry_slider_value_arr.push(key);
            }
        }
    }

    function updateSliderBackground() {
        const fromPercent = (fromSlider.value / fromSlider.max) * 100;
        const toPercent = (toSlider.value / toSlider.max) * 100;

        toSlider.style.background = `linear-gradient(to right, rgb(240, 240, 240) ${fromPercent}%, rgb(113, 168, 145) ${fromPercent}%, rgb(113, 168, 145) ${toPercent}%, rgb(240, 240, 240) ${toPercent}%)`;
    }

    function updateInputValues() {
        const fromIndex = Math.min(Math.max(parseInt(fromSlider.value, 10), 0), symmetry_slider_value_arr.length - 1);
        const toIndex = Math.min(Math.max(parseInt(toSlider.value, 10), 0), symmetry_slider_value_arr.length - 1);

        const fromValue = symmetry_slider_value_arr[fromIndex] || "Unknown";
        const toValue = symmetry_slider_value_arr[toIndex] || "Unknown";

        vdbSetUrlParams("Symmetry_from", fromValue);
        vdbSetUrlParams("Symmetry_to", toValue);

        window.VDB_DIAMOND_SELECTED_VALUES.symmetry = [fromValue, toValue].join(",");
        window.VDB_DIAMOND_SELECTED_VALUES.page = 1;

        document.querySelectorAll(".vdb-slider-label-Symmentry").forEach(label => label.classList.remove("vdb-slider-label-active"));

        const fromLabel = document.querySelector(`.vdb-slider-label-Symmentry[data-value="${fromValue}"]`);
        const toLabel = document.querySelector(`.vdb-slider-label-Symmentry[data-value="${toValue}"]`);

        if (fromLabel) fromLabel.classList.add("vdb-slider-label-active");
        if (toLabel) toLabel.classList.add("vdb-slider-label-active");

    }

    function applyInitialValues() {
        const params = new URLSearchParams(window.location.search);
        const fromParam = params.get("Symmetry_from") || symmetry_slider_value_arr[0];
        const toParam = params.get("Symmetry_to") || symmetry_slider_value_arr[symmetry_slider_value_arr.length - 1];

        const fromIndex = symmetry_slider_value_arr.indexOf(fromParam);
        const toIndex = symmetry_slider_value_arr.indexOf(toParam);

        fromSlider.value = fromIndex !== -1 ? fromIndex : 0;
        toSlider.value = toIndex !== -1 ? toIndex : symmetry_slider_value_arr.length - 1;

        updateSliderBackground();
        updateInputValues();
    }

    function updateSliderLooking() {
        let fromValue, toValue;
        let looking = window.VDB_DIAMOND_SELECTED_VALUES?.looking;

        switch (looking) {
            case "Most Popular":
            case "Best Balance":
                fromValue = "Ideal";
                toValue = "Excellent";
                break;
            case "Ultra Ideale":
                fromValue = "VeryGood";
                toValue = "VeryGood";
                break;
            default:
                console.warn("Invalid looking value:", looking);
                return;
        }

        const fromIndex = symmetry_slider_value_arr.indexOf(fromValue);
        const toIndex = symmetry_slider_value_arr.indexOf(toValue);

        if (fromIndex === -1 || toIndex === -1) {
            console.error("Symmetry values not found:", fromValue, toValue);
            return;
        }

        fromSlider.value = fromIndex;
        toSlider.value = toIndex;
        updateSliderBackground();
        updateInputValues();
        vdbMainAPiCall();
    }

    fromSlider.addEventListener('input', () => {
         const fromIndex = parseInt(fromSlider.value, 10);
        const toIndex = parseInt(toSlider.value, 10);

        if (fromIndex >= toIndex) {
          fromSlider.value = toIndex;
        }
        updateInputValues();
        updateSliderBackground();
        lookingremove();
        vdbMainAPiCall();
    });

    toSlider.addEventListener('input', () => {
        const fromIndex = parseInt(fromSlider.value, 10);
        const toIndex = parseInt(toSlider.value, 10);

        if (fromIndex >= toIndex) {
          toSlider.value = fromIndex;
        }
        updateInputValues();
        updateSliderBackground();
        lookingremove();
        vdbMainAPiCall();
    });

    let lastLookingValue = window.VDB_DIAMOND_SELECTED_VALUES?.looking;
    setInterval(() => {
        if (window.VDB_DIAMOND_SELECTED_VALUES?.looking !== lastLookingValue) {
            lastLookingValue = window.VDB_DIAMOND_SELECTED_VALUES?.looking;
            updateSliderLooking();
        }
    }, 500);

    applyInitialValues();
}


// Depth Slider
function initDepth() {
    const fromSlider = document.getElementById("vbdrb_Depth_from_slider_natural_web");
    const toSlider = document.getElementById("vbdrb_Depth_to_slider_natural_web");
    const fromInput = document.getElementById("vbdrb_Depth_from_slider_input_natural_web");
    const toInput = document.getElementById("vbdrb_Depth_to_slider_input_natural_web");

    const minDepth = parseFloat(fromSlider.min) || 0;
    const maxDepth = parseFloat(toSlider.max) || 100;

    function updateSliderFill() {
        const fromValue = parseFloat(fromSlider.value);
        const toValue = parseFloat(toSlider.value);

        const fromPercent = ((fromValue - minDepth) / (maxDepth - minDepth)) * 100;
        const toPercent = ((toValue - minDepth) / (maxDepth - minDepth)) * 100;

        const gradient = `linear-gradient(to right, #eee ${fromPercent}%, #71a891 ${fromPercent}%, #71a891 ${toPercent}%, #eee ${toPercent}%)`;
        fromSlider.style.background = gradient;
        toSlider.style.background = gradient;
    }

    function updateInputs(triggerApi = true) {
        let fromValue = parseFloat(fromSlider.value);
        let toValue = parseFloat(toSlider.value);

        if (fromValue > toValue) fromValue = toValue;
        if (toValue < fromValue) toValue = fromValue;

        fromInput.value = fromValue;
        toInput.value = toValue;
        fromSlider.value = fromValue;
        toSlider.value = toValue;

        if (typeof window.VDB_DIAMOND_SELECTED_VALUES !== "object") {
            window.VDB_DIAMOND_SELECTED_VALUES = {};
        }

        window.VDB_DIAMOND_SELECTED_VALUES.depth_min = fromValue;
        window.VDB_DIAMOND_SELECTED_VALUES.depth_max = toValue;
        window.VDB_DIAMOND_SELECTED_VALUES.page = 1;

        vdbSetUrlParams("Depth_from", fromValue);
        vdbSetUrlParams("Depth_to", toValue);

        updateSliderFill();

        if (triggerApi) {
            vdbMainAPiCall();
        }
    }

    function validateInput(input, slider) {
        let value = parseFloat(input.value);
        if (isNaN(value) || value < minDepth) value = minDepth;
        if (value > maxDepth) value = maxDepth;

        input.value = value;
        slider.value = value;
        updateInputs();
    }

    function applyInitialValues() {
        const params = new URLSearchParams(window.location.search);
        let fromValue = params.get("Depth_from") ? parseFloat(params.get("Depth_from")) : minDepth;
        let toValue = params.get("Depth_to") ? parseFloat(params.get("Depth_to")) : maxDepth;

        if (isNaN(fromValue) || fromValue < minDepth) fromValue = minDepth;
        if (isNaN(toValue) || toValue > maxDepth) toValue = maxDepth;
        if (fromValue > toValue) fromValue = toValue;

        fromSlider.value = fromValue;
        toSlider.value = toValue;
        fromInput.value = fromValue;
        toInput.value = toValue;

        updateSliderFill();
        updateInputs(false);
    }

    fromSlider.addEventListener("input", () => updateInputs(true));
    toSlider.addEventListener("input", () => updateInputs(true));
    fromInput.addEventListener("input", () => validateInput(fromInput, fromSlider));
    toInput.addEventListener("input", () => validateInput(toInput, toSlider));

    applyInitialValues();
}

// Table Slider
function initTable() {
    const fromSlider = document.getElementById("vbdrb_Table_from_slider_natural_web");
    const toSlider = document.getElementById("vbdrb_Table_to_slider_natural_web");
    const fromInput = document.getElementById("vbdrb_Table_from_slider_input_natural_web");
    const toInput = document.getElementById("vbdrb_Table_to_slider_input_natural_web");

    const minTable = parseFloat(fromSlider.min) || 0;
    const maxTable = parseFloat(toSlider.max) || 100;

    function updateSliderFill() {
        const fromValue = parseFloat(fromSlider.value);
        const toValue = parseFloat(toSlider.value);

        const fromPercent = ((fromValue - minTable) / (maxTable - minTable)) * 100;
        const toPercent = ((toValue - minTable) / (maxTable - minTable)) * 100;

        const gradient = `linear-gradient(to right, #eee ${fromPercent}%, #71a891 ${fromPercent}%, #71a891 ${toPercent}%, #eee ${toPercent}%)`;
        fromSlider.style.background = gradient;
        toSlider.style.background = gradient;
    }

    function updateInputs(triggerApi = true) {
        let fromValue = parseFloat(fromSlider.value);
        let toValue = parseFloat(toSlider.value);

        if (fromValue > toValue) fromValue = toValue;
        if (toValue < fromValue) toValue = fromValue;

        fromInput.value = fromValue;
        toInput.value = toValue;
        fromSlider.value = fromValue;
        toSlider.value = toValue;

        if (typeof window.VDB_DIAMOND_SELECTED_VALUES !== "object") {
            window.VDB_DIAMOND_SELECTED_VALUES = {};
        }

        window.VDB_DIAMOND_SELECTED_VALUES.table_min = fromValue;
        window.VDB_DIAMOND_SELECTED_VALUES.table_max = toValue;
        window.VDB_DIAMOND_SELECTED_VALUES.page = 1;

        vdbSetUrlParams("Table_from", fromValue);
        vdbSetUrlParams("Table_to", toValue);

        updateSliderFill();
        
        if (triggerApi) {
            vdbMainAPiCall();
        }
    }

    function validateInput(input, slider) {
        let value = parseFloat(input.value);
        if (isNaN(value) || value < minTable) value = minTable;
        if (value > maxTable) value = maxTable;

        input.value = value;
        slider.value = value;
        updateInputs();
    }

    function applyInitialValues() {
        const params = new URLSearchParams(window.location.search);
        let fromValue = params.get("Table_from") ? parseFloat(params.get("Table_from")) : minTable;
        let toValue = params.get("Table_to") ? parseFloat(params.get("Table_to")) : maxTable;

        if (isNaN(fromValue) || fromValue < minTable) fromValue = minTable;
        if (isNaN(toValue) || toValue > maxTable) toValue = maxTable;
        if (fromValue > toValue) fromValue = toValue;

        fromSlider.value = fromValue;
        toSlider.value = toValue;
        fromInput.value = fromValue;
        toInput.value = toValue;

        updateSliderFill();
        updateInputs(false);
    }

    fromSlider.addEventListener("input", () => updateInputs(true));
    toSlider.addEventListener("input", () => updateInputs(true));
    fromInput.addEventListener("input", () => validateInput(fromInput, fromSlider));
    toInput.addEventListener("input", () => validateInput(toInput, toSlider));

    applyInitialValues();
}

// view change 
document.addEventListener("DOMContentLoaded", function () {
    const diamonds = document.querySelector("#vdb-rb-results-count");
    const countcompare = document.querySelector("#vdb-rb-results-count-compare");
    const listbtn = document.querySelector("#list-stone-tab-view");
    const gridbtn = document.querySelector("#grid-stone-tab-view");
    const listview = document.querySelector("#vdbrb_stone_list_view_row");
    const gridview = document.querySelector("#vdbrb_stone_grid_view_row");
    const compareview = document.querySelector("#vdb-compare-view");

    function showView(viewToShow) {
        if (listview) listview.style.display = "none";
        if (gridview) gridview.style.display = "none";
        if (compareview) compareview.style.display = "none";
        if (viewToShow) viewToShow.style.display = "flex";
    }

    function updateTabView(view) {
        if (window.VDB_DIAMOND_SELECTED_VALUES) {
            window.VDB_DIAMOND_SELECTED_VALUES.tab_view = view;
        } else {
            console.warn("VDB_DIAMOND_SELECTED_VALUES is not defined!");
        }

        if (typeof vdbMainAPiCall === "function") {
            vdbMainAPiCall();
        } else {
            console.error("vdbMainAPiCall is not defined!");
        }
    }

    const selectedView = localStorage.getItem("selectedTabView")
    localStorage.setItem("selectedTabView", 'grid');
    vdbSetUrlParams("tab_view", 'grid')


    if (diamonds) {
        diamonds.addEventListener("click", function () {
            const viewChoice = localStorage.getItem("selectedTabView");
            if (viewChoice == 'list') {
                showView(listview);
            } else {
                showView(gridview)
            }
            diamonds.classList.add("vdb-rb-btn");
            if (countcompare) countcompare.classList.remove("vdb-rb-btn");
            vdbSetUrlParams("tab_view", viewChoice)
        });
    }

    if (countcompare) {
        countcompare.addEventListener("click", function (e) {
            let compareContainer = document.querySelector(".vdb-compare-container");

            if (compareContainer.querySelectorAll(".vdb-compare-card").length < 2) {
                e.preventdefault();
                return;
            }
            showView(compareview);
            countcompare.classList.add("vdb-rb-btn");
            if (diamonds) diamonds.classList.remove("vdb-rb-btn");
            document.querySelector(".vdbrb_list_cover_loader").style.display = "none"
        });
    }

    if (listbtn) {
        listbtn.addEventListener("click", function () {
            showView(listview);
            listbtn.classList.add("stone-tab-view");
            listbtn.querySelector('svg path').setAttribute('fill', 'black');
            gridbtn.querySelector('svg path').setAttribute('fill', '#8B8B8B');

            if (gridbtn) gridbtn.classList.remove("stone-tab-view");
            if (diamonds) diamonds.classList.add("vdb-rb-btn");
            if (countcompare) countcompare.classList.remove("vdb-rb-btn");
            updateTabView('list');
            vdbSetUrlParams("tab_view", 'list')
            localStorage.setItem("selectedTabView", 'list');
            document.querySelector(".vdbrb_list_cover_loader").style.display = "block"
            clearCompareList();
            vdbMainAPiCall();
        });
    }

    if (gridbtn) {
        gridbtn.addEventListener("click", function () {
            showView(gridview);
            gridbtn.classList.add("stone-tab-view");
            listbtn.querySelector('svg path').setAttribute('fill', '#8B8B8B');
            gridbtn.querySelector('svg path').setAttribute('fill', 'black');
            if (listbtn) listbtn.classList.remove("stone-tab-view");
            if (diamonds) diamonds.classList.add("vdb-rb-btn");
            if (countcompare) countcompare.classList.remove("vdb-rb-btn");
            updateTabView('grid');
            vdbSetUrlParams("tab_view", 'grid')
            localStorage.setItem("selectedTabView", 'grid');
            clearCompareList();
            vdbMainAPiCall();
        });
    }

    gridbtn.click();
});

// Compare add 
document.addEventListener("DOMContentLoaded", function () {
    document.body.addEventListener("change", handleCheckboxChange);
    updateCompareCount();
});

function updateCompareCount() {
    const compareContainer = document.querySelector(".vdb-compare-container");
    const compareCountElement = document.querySelector("#vdb-rb-results-count-compare");

    if (compareContainer && compareCountElement) {
        const count = compareContainer.querySelectorAll(".vdb-compare-card").length;
          compareCountElement.textContent = `Comparar (${count})`;
    }
}

function clearCompareList() {
    const compareContainer = document.querySelector(".vdb-compare-container");
    const compareCountElement = document.querySelector("#vdb-rb-results-count-compare");

    if (compareContainer && compareCountElement) {
        const count = compareContainer.innerHTML = "";
        compareCountElement.textContent = `Comparar (0)`;
    }
}

function handleCheckboxChange(event) {
    const checkbox = event.target;
    if (!checkbox.classList.contains("diamond-checkbox")) return;
    const index = checkbox.getAttribute("data-index");

    const viewChoice = localStorage.getItem("selectedTabView");
    let diamond = {};
    if (viewChoice == 'grid') {
        const diamondCardElement = document.querySelector(`.vdb-rb-list-product-item[data-index="${index}"]`);
        const imageElement = diamondCardElement.querySelector('.vdb-rb-img-fluid');
        const priceElement = diamondCardElement.querySelector('.vdb-diamond-price');
        const detailText = diamondCardElement.querySelector('.vdb-diamond-card-details p')?.textContent || '';
        const caratShape = detailText.split(/[\s/]+/);
        const cutElement = diamondCardElement.querySelector('.diamond-cut');
        const colorElement = diamondCardElement.querySelector('.diamond-color');
        const clarityElement = diamondCardElement.querySelector('.diamond-clarity');
        const AddSettingUrl = diamondCardElement.querySelector('.vdb-diamond-add-to-setting');
        const ViewDetails = diamondCardElement.querySelector('.vdb-diamond-view-details');

        diamond = {
            image: imageElement ? imageElement.src : 'path/to/default-image.jpg',
            carat: caratShape[0] || 'Unknown',
            shape: caratShape[2] || 'Unknown',
            price: priceElement ? priceElement.textContent.trim() : 'N/A',
            cut: cutElement ? cutElement.value : 'N/A',
            color: colorElement ? colorElement.value : 'N/A',
            clarity: clarityElement ? clarityElement.value : 'N/A',
            addsettingurl: AddSettingUrl ? AddSettingUrl.href : 'N/A',
            viewdetails: ViewDetails ? ViewDetails.href : 'N/A'
        };
    } else {
        const diamondRow = document.querySelector(`.vdb-diamond-details-tr[data-index="${index}"]`);
        const diamonddetailsrow = document.querySelector(`.diamond-details-row[data-index="${index}"]`);

        const imageElement = diamonddetailsrow.querySelector(".vdb-diamond-image img");
        const caratShapeText = diamonddetailsrow.querySelector(".vdb-details-list h2");
        const priceElement = diamonddetailsrow.querySelector(".td-price");
        const cutElement = diamonddetailsrow.querySelector("#table-cut");
        const colorElement = diamonddetailsrow.querySelector("#table-color");
        const clarityElement = diamonddetailsrow.querySelector("#table-clarity");
        const AddToSetting = diamonddetailsrow.querySelector(".vdb-diamond-add-to-setting");
        const ViewDetails = diamonddetailsrow.querySelector(".vdb-diamond-view-details");

        const caratShape = caratShapeText.textContent.split(" ");
        diamond = {
            image: imageElement ? imageElement.src : "path/to/default-image.jpg",
            price: priceElement.textContent || "N/A",
            addsettingurl: AddToSetting ? AddToSetting.href : "#",
            viewdetails: ViewDetails ? ViewDetails.href : "#"
        };

        if (window.VDB_TABLE_CARAT_SHOW === true && caratShape.length > 0) {
            diamond.carat = caratShape[0] || "Unknown";
        }
        if (window.VDB_TABLE_SHAPE_SHOW === true && caratShape.length > 2) {
            diamond.shape = caratShape[2] || "Unknown";
        }
        if (window.VDB_TABLE_CUT_SHOW === true && cutElement) {
            diamond.cut = cutElement.textContent.split(":").pop().trim() || "N/A";
        }
        if (window.VDB_TABLE_COLOR_SHOW === true && colorElement) {
            diamond.color = colorElement.textContent.split(":").pop().trim() || "N/A";
        }
        if (window.VDB_TABLE_CLARITY_SHOW === true && clarityElement) {
            diamond.clarity = clarityElement.textContent.split(":").pop().trim() || "N/A";
        }
    }

    let compareContainer = document.querySelector(".vdb-compare-container");

    if (!compareContainer) {
        compareContainer = document.createElement("div");
        compareContainer.classList.add("vdb-compare-container");
        document.body.appendChild(compareContainer);
    }

    if (checkbox.checked) {
        let existingCard = document.querySelector(`.vdb-compare-card[data-index='${index}']`);
        if (existingCard) return;

        const compareCard = document.createElement("div");
        compareCard.classList.add("vdb-compare-card");
        compareCard.setAttribute("data-index", index);
        compareCard.innerHTML = `
              <div class="vdb-compare-image">
                  <img src="${diamond.image}" alt="Diamond" onerror="this.src='https://cdn.shopify.com/s/files/1/0913/9354/files/no-image_a4338291-f650-49f3-b2f0-7f79786e044e_430x.png?v=1744950079'">
              </div>
              <div class="vdb-compare-info">
                  <h2>${diamond.carat} Quilate ${diamond.shape} Diamond</h2>
                  <p class="vdb-compare-price">${diamond.price}</p>
                  <div class="vdb-compare-grid-info">
                       ${window.VDB_TABLE_CARAT_SHOW == true ? `<p>Quilate: ${diamond.carat}</p>` : ""}
                       ${window.VDB_TABLE_CUT_SHOW == true ? `<p>Corte: ${diamond.cut}</p>` : ""}
                       ${window.VDB_TABLE_COLOR_SHOW == true ? `<p>Color: ${diamond.color}</p>` : ""}
                       ${window.VDB_TABLE_CLARITY_SHOW == true ? `<p>Claridad: ${diamond.clarity}</p>` : ""}
                  </div>
                  <a href="${diamond.addsettingurl}"  class="vdb-compare-add-to-setting">Agregar a la montura</a>
                  <a href="${diamond.viewdetails}" class="vdb-compare-view-details">Ver detalles</a>
              </div>
          `;

        compareContainer.appendChild(compareCard);
    } else {
        document.querySelector(`.vdb-compare-card[data-index='${index}']`)?.remove();
    }
    updateCompareCount();

    const compareCheckboxes = document.querySelectorAll(".diamond-checkbox");

    if (compareContainer.querySelectorAll(".vdb-compare-card").length >= 3) {
        compareCheckboxes.forEach((item, index) => {
            if (!item.checked) item.disabled = true;
        })
    } else {
        compareCheckboxes.forEach((item, index) => {
            item.disabled = false;
        })
    }
}

// sort by
document.addEventListener("DOMContentLoaded", function () {
    const sortLabel = document.querySelector(".vdb-sort");
    const sortBox = document.querySelector(".sort-box");
    const arrowsort = document.querySelector(".arrow-sort");
    const sorttext = document.querySelectorAll(".sort-text-box-h4");

    if (sortLabel && sortBox && arrowsort) {
        sortLabel.addEventListener("click", function () {
            if (sortBox.style.display === "block") {
                sortBox.style.display = "none";
                arrowsort.style.transform = "rotate(45deg)";
                arrowsort.classList.remove('active-sort');
            } else {
                sortBox.style.display = "block";
                arrowsort.style.transform = "rotate(-135deg)";
                arrowsort.classList.add('active-sort');
            }
        });

        document.addEventListener("click", function (event) {
            if (!sortLabel.contains(event.target) && !sortBox.contains(event.target)) {
                sortBox.style.display = "none";
                arrowsort.style.transform = "rotate(45deg)";
                arrowsort.classList.remove('active-sort');
            }
        });
    }
});

// View Advanced Filters open 
document.addEventListener("DOMContentLoaded", function () {
    init();
    sortingInit();
    const filterBtn = document.querySelector(".view-filters-btn");
    const filterBtnArrow = document.querySelector(".view-filters-btn .arrow");
    const filtersContainers = document.querySelectorAll(".filters_open");

    filterBtn.addEventListener("click", function () {
        let isHidden = getComputedStyle(filtersContainers[0]).display === "none";

        filtersContainers.forEach((filter) => {
            filter.style.display = isHidden ? "block" : "none";
        });

        filterBtnArrow.style.transform = isHidden ? "rotate(227deg)" : "rotate(45deg)";
    });

    let resetBtn = document.querySelector(".reset-btn");
    resetBtn.addEventListener("click", function () {
        let tabView = url.searchParams.get("tab_view");
        let ringHandle = url.searchParams.get("ring-handle");
        url.search = "";
        window.history.pushState(null, "", url.toString());
        vdbSetUrlParams("tab_view", tabView);
        vdbSetUrlParams("ring-handle", ringHandle);

        urlParams = new URLSearchParams(window.location.search);
        url = new URL(window.location.href);

        window.VDB_DIAMOND_SELECTED_VALUES.sorting = null;
        window.VDB_DIAMOND_SELECTED_VALUES.sorting_seq = null;
        window.VDB_DIAMOND_SELECTED_VALUES.looking = null;
        init();
    });
});

function vdbSetUrlParams(key, value) {
    url.searchParams.set(key, value);
    window.history.pushState(null, "", url.toString());
}